import React, { useEffect, useState } from "react";
import Button from "../../extras/Button";
import { ExInput } from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import {
  allUserNotification,
  expertNotification,
  userNotification,
} from "../../../redux/slice/notificationSlice";
import { permissionError } from "../../../util/Alert";
import { Box, Modal } from "@mui/material";

const NotificationDialog = () => {
  const dispatch = useDispatch();
  const { dialogueData } = useSelector((state) => state.dialogue);

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [image, setImage] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const hasPermission = useSelector((state) => state.auth.admin.flag);

  const [error, setError] = useState({
    title: "",
    message: "",
  });

  const handleSubmit = () => {
    if (!hasPermission) return permissionError();
    if (!title || !message) {
      let error = {};
      if (!title) error.title = "Title is Required";
      if (!message) error.message = "Message is Required";
      return setError({ ...error });
    } else {
      if (image?.length !== 0) {
        let payload;
        const formData = new FormData();
        formData.append("title", title);
        formData.append("message", message);
        formData.append("image", image);
        if (dialogueData.type === "user") {
          payload = {
            data: formData,
            userId: dialogueData.id,
          };
          dispatch(userNotification(payload)).unwrap();
        } else if (dialogueData.type === "expert") {
          payload = {
            data: formData,
            expertId: dialogueData.id,
          };
          dispatch(expertNotification(payload)).unwrap();
        }
      } else {
        let payload;
        if (dialogueData.type === "user") {
          payload = {
            data: {
              title,
              message,
            },
            userId: dialogueData.id,
          };
          dispatch(userNotification(payload)).unwrap();
        } else if (dialogueData.type === "expert") {
          payload = {
            data: {
              title,
              message,
            },
            expertId: dialogueData.id,
          };
          dispatch(expertNotification(payload)).unwrap();
        }
      }
      dispatch(closeDialog());
    }
  };

  const handleAllUser = () => {
    if (!hasPermission) return permissionError();
    let payload;
    if (!title || !message) {
      let error = {};
      if (!title) error.title = "Title is Required";
      if (!message) error.message = "Message is Required";
      return setError({ ...error });
    } else {
      if (image.length !== 0) {
        const formData = new FormData();
        formData.append("title", title);
        formData.append("message", message);
        formData.append("image", image);

        dispatch(allUserNotification(formData)).unwrap();
      } else {
        payload = {
          title,
          message,
        };
        dispatch(allUserNotification(payload)).unwrap();
      }
      dispatch(closeDialog());
    }
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
    setImagePath(URL.createObjectURL(e.target.files[0]));
    setError((prevErrors) => ({
      ...prevErrors,
      image: "",
    }));
  };

  return (
    <Modal
      open={true}
      onClose={closeDialog}
    >
    <Box className="model-style">
        <div className="model-header">
          <p className="m-0">User Notification</p>
        </div>
      
               <div className="model-body">
                <div className="row align-items-start formBody">
                  <div className="col-6">
                    <ExInput
                      type={`text`}
                      id={`title`}
                      name={`title`}
                      value={title}
                      label={`Title`}
                      placeholder={`Title`}
                      errorMessage={error && error.title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                        if (!e.target.value) {
                          setError({
                            title: "Title is required",
                          });
                        } else {
                          setError({
                            title: "",
                          });
                        }
                      }}
                    />
                  </div>

                  <div className="col-6">
                    <ExInput
                      type={`text`}
                      id={`message`}
                      name={`message`}
                      value={message}
                      label={`Message`}
                      placeholder={`Message`}
                      errorMessage={error && error.message}
                      onChange={(e) => {
                        setMessage(e.target.value);
                        if (!e.target.value) {
                          setError({
                            message: "Message is required",
                          });
                        } else {
                          setError({
                            message: "",
                          });
                        }
                      }}
                    />
                  </div>

                  <div className="col-12">
                    <ExInput
                      label={`Image`}
                      id={`image`}
                      type={`file`}
                      onChange={(e) => handleImage(e)}
                      errorMessage={error.image && error.image}
                      accept={"image/*"}
                    />
                    <img
                      src={imagePath !== "" ? imagePath : null}
                      alt=""
                      draggable="false"
                      className={`${
                        (!imagePath || imagePath === "") && "d-none"
                      } `}
                      data-class={`showImage`}
                      style={{ width: "100px", height: "100px" }}
                    />
                  </div>
                </div>
               </div>
                <div className="model-footer">
                  <div className="m-3 d-flex justify-content-end gap-2">
                    <Button
                      className={`close-model-btn`}
                      text={`Cancel`}
                      type={`button`}
                      onClick={() => dispatch(closeDialog())}
                    />
                    {dialogueData && (
                      <Button
                        type={`submit`}
                        text={`Submit`}
                        onClick={(e) => handleSubmit(e)}
                      />
                    )}
                    {dialogueData == null && (
                      <Button
                        type={`submit`}
                        className={`text-white m10-left`}
                        style={{ backgroundColor: "#1ebc1e" }}
                        text={`Submit`}
                        onClick={(e) => handleAllUser(e)}
                      />
                    )}
                  </div>
                </div>
             
    </Box>
    </Modal>
  );
};

export default NotificationDialog;